var render = function render(){var _vm=this,_c=_vm._self._c;return _c('myTable',{attrs:{"categoryName":'类型',"isShowNo":true,"type":4}})
}
var staticRenderFns = []

export { render, staticRenderFns }